import React, { Fragment } from "react";
import constants from "../constants";

const Navigation = ({ links = [], contentLink = null }) => {
  let menuRef = React.createRef();
  function toggleMenu() {
    menuRef.current.classList.toggle("navbar__menu--show");
  }
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const hasChildrenClass = links.length > 0 ? "has-children" : null;
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;

  return (
    <Fragment>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon sicon-menu"
          onClick={toggleMenu}
        ></a>
      ) : (
        <Fragment>
          <a
            className={`navbar__link ${hasChildrenClass || ""} ${
              additionClass || ""
            }`}
            href={contentLink.url || contentLink.url}
            target = {contentLink.openInNewTab ? "_blank" : "_parent"}
            dangerouslySetInnerHTML={{
              __html: `<span>${contentLink.name}</span>`,
            }}
          ></a>
          {links.length > 0 && (
            <i
              className="sicon-chevron-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <ul className="navbar__menu" ref={menuRef}>
          <div className="navbar__menu-header">
            {!contentLink ? (
              <span
                className="navbar__icon navbar__icon--close sicon-x"
                onClick={toggleMenu}
              ></span>
            ) : (
              <Fragment>
                <span
                  className="navbar__title"
                  onClick={toggleMenu}
                  dangerouslySetInnerHTML={{ __html: contentLink.name }}
                ></span>
                <i
                  className="sicon-chevron-down navbar__icon"
                  onClick={toggleMenu}
                ></i>
              </Fragment>
            )}
          </div>
          <div className="navbar__menu-top"></div>
          {links.length > 0 &&
            links.map(
              (link, i) =>
                hasNameOrChildren(link) && (
                  <li
                    className="navbar__item"
                    key={
                      !link.name
                        ? `${new Date().getTime()}-${i}`
                        : `${link.name}-${i}`
                    }
                  >
                     
                  <div
                      className={`navbar__item-container${
                      link.isCategory ? "" : " content-link"
                      }`}
                  >
                      <div className="navbar__item-image">
                          {(link.imageUrl) &&
                              <img src={link.imageUrl}></img>
                          }
                      </div>
                  </div>
                      
                    <Navigation links={link.links} contentLink={link} />
                  </li>
                )
            )}
          <div className="navbar__menu-bottom">
            <div className="navbar__menu-wave">
              <div className="wave-svg__container"></div>
            </div>
          </div>
        </ul>
      )}
    </Fragment>
  );
};

export default Navigation;
